var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-app-bar',{attrs:{"flat":""}},[_c('v-img',{attrs:{"src":"/img/logo-grey-2x.png"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }